import type { IEngagementFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import type { ColumnByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/column-by-keys";
import type { SuggestedColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";

import * as columnNames from "../../constants/column-names";
import { processColumnsByKeys } from "../processColumnsByKeys";

const COLUMNS_BY_KEYS: ColumnByKeys<IEngagementFilterDto> = {
    bounceRate: [
        columnNames.BOUNCE_RATE_FIELD,
        columnNames.DESKTOP_BOUNCE_RATE_FIELD,
        columnNames.MOBILEWEB_BOUNCE_RATE_FIELD,
    ],

    avgVisitDuration: [
        columnNames.VISIT_DURATION_FIELD,
        columnNames.DESKTOP_VISIT_DURATION_FIELD,
        columnNames.MOBILEWEB_VISIT_DURATION_FIELD,
    ],
    avgPagesPerVisit: [
        columnNames.PAGES_PER_VISIT_FIELD,
        columnNames.DESKTOP_PAGES_PER_VISIT_FIELD,
        columnNames.MOBILEWEB_PAGES_PER_VISIT_FIELD,
    ],
    avgVisitsPerUser: [columnNames.AVG_VISITS_PER_USER_FIELD],
};

const processEngagementFilter = (filterDto: Partial<IEngagementFilterDto>): readonly SuggestedColumnName[] => {
    return processColumnsByKeys<IEngagementFilterDto>(filterDto, COLUMNS_BY_KEYS);
};

export default processEngagementFilter;
